import React from 'react'
import { Checkbox } from '../Checkbox'
import styles from '../Checkbox/checkbox.module.css'

interface CheckboxFieldProps {
    label: string
    modifier: string
    value: boolean | undefined
    onChange: React.ChangeEventHandler<HTMLInputElement>
    qaTag: string
    id: string
    name: string
    error: string | undefined
}

const CheckboxField = ({ label, modifier, value, onChange, qaTag, id, name, error }: CheckboxFieldProps) => {
    return (
        <>
            <Checkbox
                label={label}
                modifier={modifier}
                checked={value}
                onchange={onChange}
                qaTag={qaTag}
                id={id}
                name={name}
                error={error}
            />
            {error && (
                <div className={styles['error-message']} data-qat="checkbox-error-message">
                    {error}
                </div>
            )}
        </>
    )
}

export default CheckboxField
